module.exports = __webpack_public_path__ + "static/media/Galley_Banner.3a52661b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/Galley_Banner.jpg
// module id = 1757
// module chunks = 0